module.exports = __webpack_public_path__ + "static/media/favicon.41cf7239.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 1726
// module chunks = 15